import React from 'react';
import PublicLayout from '../components/Public/PublicLayout';
import RevealBlock from '../components/Public/RevealBlock';
import standardProductImage from '../assets/public/product_standard.png';
import customProductImage from '../assets/public/product_custom.png';
import '../styles/PublicSite.css';

const standardProducts = [
  { id: 'gma03', name: 'Tarima tipo europea (GMA03)' },
  { id: 'americana', name: 'Tarima tipo americana' },
  { id: 'tablillas', name: 'Tarima 10 tablillas' },
];

const ProductosLanding = () => {
  return (
    <PublicLayout>
      <section className="products-page products-page-modern">
        <RevealBlock className="products-heading" delay={70}>
          <h1>Palets Standard 40" x 48"</h1>
          <p>Modelos listos para operacion logistica e industria de exportacion.</p>
        </RevealBlock>

        <div className="products-grid">
          {standardProducts.map((product, index) => (
            <RevealBlock key={product.id} className="product-card" delay={120 + index * 90}>
              <article className="product-card-inner">
                <div className="product-image-wrap">
                  <img src={standardProductImage} alt={product.name} />
                </div>
                <p>{product.name}</p>
              </article>
            </RevealBlock>
          ))}
        </div>

        <RevealBlock className="products-heading secondary" delay={170}>
          <h2>Palets a la medida</h2>
        </RevealBlock>

        <RevealBlock className="custom-product" delay={210}>
          <article className="custom-product-image-wrap">
            <img src={customProductImage} alt="Palet a la medida" />
          </article>

          <div className="custom-product-copy">
            <p>
              Ofrecemos fabricacion de palets personalizados segun requerimientos especificos de carga,
              dimensiones y tipo de uso. Este servicio aplica para pedidos por volumen y proyectos
              especiales. Cada diseno se desarrolla considerando:
            </p>
            <ul>
              <li>Tipo de mercancia</li>
              <li>Peso y distribucion de carga</li>
              <li>Medio de transporte</li>
              <li>Requisitos de exportacion</li>
            </ul>
          </div>
        </RevealBlock>
      </section>
    </PublicLayout>
  );
};

export default ProductosLanding;
